<template>
   <UApp class="relative">
    <div class="z-10 relative shadow-lg bg-zinc-50">
      <NavigationMain :navigation="data.navigation.links" />
      <NuxtLayout>
        <NuxtPage />
      </NuxtLayout>

      <ModalsContainer />
      <CookieBanner />
    </div>
    <div class="absolute inset-0" />
    <div class="sticky bottom-0 left-0 right-0 z-0">
      <NavigationFooter :navigation="data.navigation.footer" />
    </div>
  </UApp>
</template>

<script lang="ts" setup>
import { ModalsContainer } from 'vue-final-modal'

import { siteName } from '~~/content/settings/settings.json'

const { data } = await useAsyncData('navigations', () => queryContent('/settings/').find(), {
  transform: (data) => {
    const d = correctAssetRoutes(data)
    const navigation = d?.find((item: any) => item._path === '/settings/navigation')
    const settings = d?.find((item: any) => item._path === '/settings/settings')
    return {
      navigation,
      settings,
    }
  },

})

onMounted(() => {
  useState<Settings>('settings', () => data.value?.settings)
})

useHead({
  titleTemplate: (titleChunk) => {
    return titleChunk ? `${titleChunk} | ${siteName}` : `${siteName}`
  },
})

useSeoMeta({
  ogTitle: () => data.value?.settings?.siteName,
  ogImage: () => data.value?.settings?.metaImage,
  twitterTitle: () => data.value?.settings?.siteName,
  twitterImage: () => data.value?.settings?.metaImage,
})
</script>

<style>
html {
  scroll-behavior: smooth;
    scroll-padding-top: 80px; /* offset for sticky header */

}
/* Page fade transition */
.page-fade-enter-active,
.page-fade-leave-active {
  transition: opacity 0.4s ease, transform 0.4s ease;
}
.page-fade-enter-from,
.page-fade-leave-to {
  opacity: 0;
  transform: translateY(10px);
}

/* Layout slide transition */
.layout-slide-enter-active,
.layout-slide-leave-active {
  transition: all 0.4s ease;
}
.layout-slide-enter-from {
  transform: translateX(100%);
}
.layout-slide-leave-to {
  transform: translateX(-100%);
}
</style>
